// extracted by mini-css-extract-plugin
var _1 = "HYA9Qo6Q";
var _2 = "mAEfnKxT";
var _3 = "f8ysmuim";
var _4 = "xXjGbLfa";
var _5 = "QpP3QuzH";
var _6 = "dL9NNKXl";
var _7 = "nOAqJeE7";
var _8 = "mfygANtz";
var _9 = "A7BxW13J";
var _a = "u3_D2dFf";
export { _1 as "back", _2 as "backDisabled", _3 as "controls", _4 as "duration", _5 as "durationInput", _6 as "label", _7 as "pick", _8 as "sound", _9 as "soundInput", _a as "text" }
